export const environment = {
  production: true,
  api_url: 'https://api.dataspace.pl',
  for_testing: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts